import BaseResource from '@/lib/data/resource/BaseResource'

export default class NIISummaryPieAssetResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Asset = payload.component ?? ''
    this.Type = payload.type ?? ''
    this.Value = payload.value ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
